import React from 'react';
import { SignupProvider, useSignup } from './context/SignupContext';
import { SignupStep } from './types';
import { LandingPage } from './components/pages/LandingPage';
import { SignupForm } from './components/pages/SignupForm';
import { OTPVerification } from './components/pages/OTPVerification';
import { SuccessPage } from './components/pages/SuccessPage';

// Main app router component
const AppRouter: React.FC = () => {
  const { currentStep, error } = useSignup();

  // Global error display
  const ErrorBanner = () => {
    if (!error) return null;
    
    return (
      <div className="error-banner">
        <div className="container">
          {error}
        </div>
      </div>
    );
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case SignupStep.LANDING:
        return <LandingPage />;
      case SignupStep.SIGNUP:
        return <SignupForm />;
      case SignupStep.OTP_VERIFICATION:
        return <OTPVerification />;
      case SignupStep.SUCCESS:
        return <SuccessPage />;
      default:
        return <LandingPage />;
    }
  };

  return (
    <div>
      <ErrorBanner />
      <div style={{ paddingTop: error ? '2.5rem' : '0' }}>
        {renderCurrentStep()}
      </div>
    </div>
  );
};

// Main App component
const App: React.FC = () => {
  return (
    <SignupProvider>
      <div className="App">
        <AppRouter />
      </div>
    </SignupProvider>
  );
};

export default App;
